'use strict';

var _ = require('lodash');
var PIXI = require('pixi.js');
var OutlineFilter = require('./OutlineFilter');
var Utils = require('./utils');
var createSprite = require('./createSprite');

module.exports = {

    createBlobs: function(opts)
    {
        opts = _.extend({
            objectsWithTextures: {},
            blobKey: 'blob',
            groupsCount: 1,
            minBlobsCount: 6,
            maxBlobsCount: 18,
            x: 0,
            y: 0,
            group: [],
            width: 0,
            height: 0,
            blobObject: {},
            dirty: false,
            cleanable: false,
            stampable: false,
            cleanTint: 0xFFFFFF,
            dirtyTints: [0],
            outlineSize: 2,
            outlineColor: 0xFFFFFF
        }, opts);

        var state = this.state;

        var sprite = new PIXI.Container();

        if (opts.outlineSize > 0)
        {
            var outlineFilter = new OutlineFilter(window.innerWidth, window.innerHeight, opts.outlineSize, opts.outlineColor);
            sprite.filters = [outlineFilter];
        }

        var blobObject = _.merge(opts.objectsWithTextures[opts.blobKey], opts.blobObject);

        for (var gi = 0; gi < opts.groupsCount; gi++)
        {
            var blobsGroup = [];
            opts.group.push(blobsGroup);
            var groupY = opts.y - _.random(0, 10);
            var groupBlobsCount = _.random(opts.minBlobsCount, opts.maxBlobsCount);

            var phase = 2 * Math.PI;
            var radius = Utils.getValueInPixels(blobObject.scale.x) * opts.width * 0.75;
            var randomDisplacement = radius / 3;

            for (var bi = 0; bi < groupBlobsCount; bi++)
            {
                var ax = -radius / 2;
                var ay = 0;

                var paintedBlob = createSprite(blobObject);
                Utils.setSizeAndPositionFromRefSize(paintedBlob, opts.width, opts.height, blobObject);

                if (bi > 0)
                {
                    ax = (-radius + radius * Math.cos(phase * bi / groupBlobsCount));
                    ay = (radius * Math.sin(phase * bi / groupBlobsCount));
                } else {
                    paintedBlob.scale.x += 0.2;
                    paintedBlob.scale.y += 0.2;
                }

                paintedBlob.x += (opts.x -paintedBlob.width + ax + _.random(-randomDisplacement, randomDisplacement));
                paintedBlob.y += (groupY + ay + _.random(-randomDisplacement, randomDisplacement));
                paintedBlob.tint = opts.dirty ? opts.dirtyTints[_.random(0, opts.dirtyTints.length-1)]:opts.cleanTint;
                paintedBlob.cleanable = opts.cleanable;
                paintedBlob.stampable = opts.stampable;
                paintedBlob.cleaning = false;
                paintedBlob.stamping = false;
                blobsGroup.push(paintedBlob);
                paintedBlob.anchor.x = paintedBlob.anchor.y = 0.5;
            }

            blobsGroup = _.shuffle(blobsGroup);

            for (var ri = 0, rl = blobsGroup.length; ri < rl; ri++)
            {
                sprite.addChild(blobsGroup[ri]);
            }
        }

        return sprite;
    }
};



// WEBPACK FOOTER //
// ./js/lib/blobs.js